/**
 * One slow editorial marquee — giant outlined serif italics drifting
 * across a deep canvas. Pure CSS animation, content duplicated for a
 * seamless loop.
 */
export default function Marquee({ items, testid = "editorial-marquee", className = "" }) {
  const row = items.map((i) => i.toUpperCase()).join("  \u2022  ") + "  \u2022  ";
  return (
    <div
      data-testid={testid}
      className={`relative overflow-hidden border-y border-[#C6A87C]/15 bg-abyss py-8 lg:py-12 select-none ${className}`}
      aria-hidden="true"
    >
      <div className="animate-marquee-slow flex w-max whitespace-nowrap">
        {[0, 1].map((i) => (
          <span
            key={i}
            className="font-serif italic text-[11vw] lg:text-[7vw] leading-none text-outline-gold pr-4"
          >
            {row}
          </span>
        ))}
      </div>
    </div>
  );
}
